import { CompanyAccessMessage } from '../../../types/CompanyAccessMessage';
import { CompanyMessage } from '../../../types/CompanyMessage';

export const getSortedAccessCompanies = (companyAccesses?: CompanyAccessMessage[]): CompanyMessage[] | null => {
    if (!companyAccesses || companyAccesses.length === 0) {
        return null;
    }

    const companies = companyAccesses
        .filter((companyAccess) => companyAccess.company !== undefined)
        .map((companyAccess) => companyAccess.company!)
        .sort((c1, c2) => {
            if (!c1 || !c2) {
                return 0;
            }
            return c1.name.localeCompare(c2.name);
        });

    return companies.length > 0 ? companies : null;
};
